import { i18n } from '@/commons/utils';

// Plugin constants
const $ = window.$;
const transactionIdFromUrl = new URL(window.location.href).searchParams.get('transactionId') || '';

const settings = {
  CUBE_INVOICE_URL: Cube.Utils.localizeUri('/order/documents?invoiceOrderId='),
  CUBE_REQUEST_INVOICE_URL:
    '/rest/model/com/decathlon/cube/commerce/order/documents/CubeInvoiceActor/callCustomerInvoice?',
  CUBE_POST_INVOICE_FORM_URL:
    '/rest/model/com/decathlon/cube/commerce/order/documents/CubeInvoiceActor/sendFormToCustomerInvoice',
  OSMOSE_REQUEST_INVOICE_URL: `/rest/model/com/decathlon/cube/commerce/order/documents/CubeInvoiceActor/getOsmoseInvoiceDocuments?transactionId=${transactionIdFromUrl}&osmoseOrderId=`,

  SELECTOR: '#my-invoice',
  INVOICE_FORM_SELECTOR: '#my-invoice-block',
};

function getCustomerFields(data) {
  const fieldsCustomer = [new Field('firstName', [isRequired]), new Field('name', [isRequired])];

  if (data && data.customer.isb2b) {
    fieldsCustomer.push(new Field('companyName', [isRequired]));
  }

  if (cube.config.feature_fiscalIdForPurchaseInvoice === 'true') {
    fieldsCustomer.push(new Field('fiscalId', [isRequired], data && data.customer.isb2b ? 'b2b' : 'b2c'));
  }

  return fieldsCustomer;
}

function getAddressFields() {
  return [
    new Field('address', [isRequired]),
    new Field('zipCode', [isRequired]),
    new Field('city', [isRequired]),
    new Field('country', [isRequired]),
  ];
}

function getFields() {
  return getCustomerFields().concat(getAddressFields());
}

function callInvoiceEvent() {
  $('body')
    .find(settings.SELECTOR)
    .click(() => {
      if ($(settings.INVOICE_FORM_SELECTOR).length > 0) {
        closeMyInvoice();
      } else {
        processMyInvoice(false);
      }
    });
}

export function init() {
  let invoiceData = null;

  const downloadInvoiceButton = $(settings.SELECTOR);
  downloadInvoiceButton.off().on('click', e => {
    // Cube Order invoice case
    if (downloadInvoiceButton.attr('data-order-has-invoice') !== 'false') {
      e.preventDefault();
      window.location.href = settings.CUBE_INVOICE_URL + downloadInvoiceButton.attr('data-order-id');
      return;
    }
    // Osmose order invoice case
    if (downloadInvoiceButton.attr('data-origin') === 'OSM') {
      if (!invoiceData) {
        e.preventDefault();
        window
          .getAjaxHandler()
          .withUrl(settings.OSMOSE_REQUEST_INVOICE_URL + downloadInvoiceButton.attr('data-transaction-id'))
          .withSuccess(($this, res) => {
            if (res.responseTO.errors && res.responseTO.errors.length > 0) {
              error('customerInvoice.invoiceError');
              return;
            }

            invoiceData = res.responseTO.data;
            downloadInvoiceButton.attr('download', invoiceData.fileName);
            downloadInvoiceButton.attr('href', `data:${invoiceData.contentType};base64,${invoiceData.content}`);
            downloadInvoiceButton[0].click();
          })
          .withError(() => {
            error('customerInvoice.invoiceError');
          })
          .call();
      }
    }
  });

  if (
    $(settings.SELECTOR).length === 0 ||
    !$(settings.SELECTOR).attr('data-transaction-id') ||
    downloadInvoiceButton.attr('data-origin') === 'OSM'
  ) {
    return;
  }

  // Purchase Invoice case
  if ($(settings.INVOICE_FORM_SELECTOR).length > 0) {
    closeMyInvoice();
  } else {
    processMyInvoice(true);
  }

  callInvoiceEvent();

  $('#call-invoice').off();
  $(document).on('click', '#call-invoice', event => {
    if (!$(event.target).hasClass('has-error')) {
      postForm();
    }
  });
  $('#cancel-invoice').off();
  $(document).on('click', '#cancel-invoice', closeMyInvoice);

  if ($(settings.INVOICE_FORM_SELECTOR).length > 0) {
    const allFields = getFields();
    allFields.forEach(field => {
      $(settings.INVOICE_FORM_SELECTOR)
        .find(`input[name=${field.name}]`)
        .off();
      field.conditions.forEach(cond => {
        $(settings.INVOICE_FORM_SELECTOR)
          .find(`input[name=${field.name}]`)
          .keyup(cond);
      });
    });
  }
}

function processMyInvoice(isInit) {
  if ($('#my-invoice-form').length === 0) {
    const params = $.param({
      transactionId: $(settings.SELECTOR).attr('data-order-id'),
    });
    if (isInit) {
      window
        .getAjaxHandler()
        .withUrl(settings.CUBE_REQUEST_INVOICE_URL + params)
        .withSuccess(myInvoicePDF)
        .withError(error)
        .call();
    } else {
      window
        .getAjaxHandler()
        .withUrl(settings.CUBE_REQUEST_INVOICE_URL + params)
        .withSuccess(myInvoiceSuccess)
        .withError(error)
        .call();
    }
  }
}

function closeMyInvoice() {
  $(settings.INVOICE_FORM_SELECTOR).slideUp('slow', () => {
    $(settings.INVOICE_FORM_SELECTOR).remove();
  });
}

function generateCustomerInvoiceForm(data) {
  let newBlock =
    `${'<section id="my-invoice-block" style="display: none;">' +
      '<div class="col-sm-6 col-xs-12"><div class="pull-left"><span class="icon icon-user"></span></div><label class="dkt-field-label">'}${i18n(
      'customerInvoice.informations'
    )}</label></div>` + `<form id="my-invoice-form" class="raw">`;
  newBlock += '<div class="col-sm-12 my-invoice-fields">';
  newBlock += buildInvoiceFields(getCustomerFields(data), data);
  newBlock += buildInvoiceFields(getAddressFields(), data);
  newBlock += '</div>';
  newBlock += '<div class="col-sm-12">';
  newBlock += `<a id="call-invoice" href="javascript:void(0);" class="order-details-actions-button pull-right">${i18n(
    'customerInvoice.generate'
  )}</a>`;
  newBlock += `<a id="cancel-invoice" href="javascript:void(0);" class="order-details-actions-button pull-right">${i18n(
    'cancel'
  )}</a>`;
  newBlock += '</div></form></section>';
  $('.order-details-actions')
    .parent()
    .after(newBlock);
  $(settings.INVOICE_FORM_SELECTOR).slideDown('slow');
}

function myInvoiceSuccess($this, response) {
  if (response.result && response.result.data) {
    if (response.result.data.pdf) {
      const transactionId = $(settings.SELECTOR).attr('data-transaction-id');
      $(settings.SELECTOR).attr('download', `invoice-${transactionId}.pdf`);
      $(settings.SELECTOR).attr('href', `data:application/octet-stream;base64,${response.result.data.pdf}`);
    } else {
      generateCustomerInvoiceForm(response.result.data);
    }
  } else {
    pushAlert('danger', 'bell', i18n('customerInvoice.serviceError'));
  }
}

function myInvoicePDF($this, response) {
  if (response.result && response.result.data && response.result.data.pdf) {
    const transactionId = $(settings.SELECTOR).attr('data-transaction-id');
    $(settings.SELECTOR).attr('download', `invoice-${transactionId}.pdf`);
    $(settings.SELECTOR).attr('href', `data:application/octet-stream;base64,${response.result.data.pdf}`);
  }
}

function error(message = 'error.oc.call') {
  cube.alert.error(i18n(message));
}

function Field(name, conditions, label) {
  this.name = name;
  this.label = label || name;
  this.conditions = conditions || [];
}

function isRequired() {
  if ($(this).val() !== '') {
    $(this).removeClass('has-error');
  } else {
    $(this).addClass('has-error');
  }
  refreshCallInvoiceButton();
}

function refreshCallInvoiceButton() {
  if ($('.my-invoice-fields .has-error').length > 0) {
    $('#call-invoice').addClass('has-error');
  } else {
    $('#call-invoice').removeClass('has-error');
  }
}

function postForm() {
  decathlon.tools.displayLoader(true);

  const formArray = $('#my-invoice-form').serializeArray();
  const formObject = {};
  for (const i in formArray) {
    const item = formArray[i];
    formObject[item.name] = item.value.replace(/["']/g, '\\$&');
  }

  const sendInvoiceRequestTO = {
    customer: formObject,
    transactionId: $(settings.SELECTOR).attr('data-order-id'),
  };

  const params = {
    sendInvoiceRequestTO: JSON.stringify(sendInvoiceRequestTO),
  };

  getAjaxHandler()
    .withUrl(settings.CUBE_POST_INVOICE_FORM_URL)
    .withParameters(params)
    .withSuccess(postFormSuccess)
    .withComplete(() => {
      decathlon.tools.displayLoader(false);
    })
    .call();
}

function postFormSuccess($this, response) {
  if (response.error || !response.result.data) {
    pushAlert('danger', 'bell', i18n('customerInvoice.postError'));
  } else {
    displayInvoicePdf(response.result.data);
  }
}

function displayInvoicePdf(pdf) {
  // Why IE, Why ???
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    const byteCharacters = atob(pdf);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i += 1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: 'application/pdf',
    });
    window.navigator.msSaveOrOpenBlob(blob, 'myInvoice.pdf');
  } else {
    const transactionId = $(settings.SELECTOR).attr('data-transaction-id');
    $(settings.SELECTOR).attr('download', `invoice-${transactionId}.pdf`);
    $(settings.SELECTOR).attr('href', `data:application/octet-stream;base64,${pdf}`);
    $(document).off('click', settings.SELECTOR);
    document.getElementById($('#my-invoice').attr('id')).click();
    closeMyInvoice();
  }
}

function buildInvoiceFields(fields, data) {
  let fieldBlock = '<div class="col-sm-6 invoice-fields-container">';
  fields.forEach(field => {
    if (!field.name.startsWith('@')) {
      fieldBlock += '<div>';
      fieldBlock += `<label class="raw">${i18n(`customerInvoice.${field.label}`)} : </label>`;
      fieldBlock += `<input class="dkt-field col-xs-12" required="${field.conditions.indexOf(isRequired) >
        -1}" value="${data.customer[field.name] || ''}" name="${field.name}"/>`;
      fieldBlock += '</div>';
    }
  });
  fieldBlock += '</div>';
  return fieldBlock;
}



// WEBPACK FOOTER //
// ./src/modules-es5/account/order/myInvoice.js